export default __webpack_public_path__ + "static/media/at-work-animate.de0235ba.svg";